<template>
  <form v-on:submit="save">


      <div class="card card-info" id="divEdit" >
        <div class="card-header with-border">
          <h3 class="card-title">Examination Hall</h3>
        </div>
        <div id="studentForm">
          <div class="card-body">
            <div class="row">

              <div class="col-md-6">
                <div class="form-group">
                  <label>Name *</label>
                  <input maxlength="60" class="form-control" required="required" v-model="hall.Name" />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>Description *</label>
                  <input maxlength="60" class="form-control" v-model="hall.Description" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <label>Seating Plan *</label>
                <table class="table table-bordered table-sm table-color">
                  <thead class="bg-info text-white">
                    <tr>
                      <th style="width: 10%; text-align: center">Row #</th>
                      <th style="width: 50%; text-align: center">Row Name</th>
                      <th style="width: 20%; text-align: center">No of Seats</th>
                      <th style="width: 20%; text-align: center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in child">
                      <td style="text-align: center">{{index + 1}}</td>
                      <td>
                        <input class="form-control" maxlength="5" required="required" v-model="item.RowName" />
                      </td>
                      <td style="text-align: center">
                        <input maxlength="3" class="form-control" required="required" v-model="item.TotalSeats" v-mask="'###'">
                      </td>
                      <td style="text-align: center">
                        <button style="border: none; background-color: transparent;" v-on:click="remove(index)"><i class="fa fa-trash fa-2x"></i></button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="4">
                        <button class="btn btn-default" type="button" style="width: 100%" v-on:click="addNew()">Add New Row</button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
          <div class="card-footer" style="text-align: right">
            <button type="submit" v-show="isupdate == false" class="btn btn-success">Save</button>
            <button type="button" v-show="isupdate == true" v-on:click="update()" class="btn btn-success">Update</button>
            <button type="button"  class="btn btn-primary float-left" v-on:click="back()">Back to List</button>
          </div>
        </div>
      </div>

  </form>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        isupdate: false,
        hall: { name: '', description: '' },
        child: [], hll: [],

      }
    },
    created: function () {
      this.checkExaminationHallUpdate();
    },
    methods: {
      remove(ind) {
        this.child.splice(ind, 1);
      },

      addNew() {
        this.child.push({ RowName: '', TotalSeats: '' });
      },
      back() {
        window.location.href = "../Admission/AllExaminationHalls";
      },

      save(e) {

        e.preventDefault();
        var vm = this;
        startReq();
        axios.post('/api/AdmissionApi/newExaminationHall', {
          hall: vm.hall,
          child: vm.child
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success("Saved Successfully", "Done");
              vm.reset();
            }
            else
              toastr.error(res.data.msg);

          })
          .catch(function (err) {
            endReq();
            if (err.response) {
              var res = err.response;
              if (res.status == 401) {
                toastr.error(res.data);
              }
              else {
                for (const [key, value] of Object.entries(res.data.errors)) {
                  //console.log(`${value}`);
                  toastr.error(`${value}`);
                }
              }
            }
          })


      },
      reset() {
        this.isupdate = false;
        this.hall.name = " ";
        this.hall.description = " ";
        this.child = [];
      },

      checkExaminationHallUpdate() {
        //alert('SS')
        var vm = this;
        const params = new URLSearchParams(window.location.search);
        const interID = params.get('id');
        axios.post('/api/AdmissionApi/checkExaminationHallUpdate?id=' + interID)
          .then(function (res) {
            //alert('f')
            //alert(res.data)
            if (!res.data.status) {
              vm.isupdate = false;

            } else {
              // alert('d')
              vm.hall = res.data.hall;
              vm.child = res.data.child;
              vm.isupdate = true;

              vm.hall.InsertionDate = null;

            }
          })
          .catch(function (res) {

          });
      },

      update() {
        var vm = this;
        //for (i = 0; i < vm.child.length; i++) {
        //  if (vm.child[i].ExaminationHall)
        //    vm.child[i].ExaminationHall.InsertionDate = null
        //}
        //vm.hll.description = vm.hall.description

        //vm.hall.InsertionDate = null;
        axios.post('/api/AdmissionApi/updateExaminationHall', {
          hall: vm.hall,
          child: vm.child
        })
          .then(function (res) {
            if (res.data.status) {
              toastr.success("Saved Successfully", "Done !");
              vm.reset();
              setTimeout(function () {
                window.location = "/Admission/AllExaminationHalls";
              }, 1200);
            }
            else {
              toastr.error("", "Error!");
              console.log(rs);
            }
          })
          .catch(function (res) {

          });
      },

    }
  })
</script>



// WEBPACK FOOTER //
// src/components/onlineadmission/examinationHall.vue